<div *ngIf="visation; else loading">
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/info-icon.svg" alt="">
    </div>
    Notificaciones
  </h1>
  <div class="flex justify-between items-center mb-2">
    <h2 class="main-subtitle">Detalle notificación</h2>
    <a routerLink="/approval-notifications" class="button button-outlined-primary">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>

  <div class="single-page-content">
    <h3 class="text-primary-700 text-xl">Notificación #{{ visation.id }} - {{ visation.maintenance.maintenanceType.name }}</h3>

    <!-- Tabla principal con <tbody> -->
    <table class="table table-report-info w-full mb-4 hidden md:table text-sm">
      <tbody> <!-- Agregado el tbody -->
        <tr>
          <th>Solicitante:</th>
          <td>{{ visation.requestingUser.username }}</td>
          <th>Tipo de cambio:</th>
          <td>{{ visation.changeType }}</td>
        </tr>
        <tr>
          <th>Tarea:</th>
          <td>{{ visation.task || 'N/A' }}</td>
          <th>Estado:</th>
          <td>{{ visation.status ? 'Aprobado' : 'Pendiente' }}</td>
        </tr>
        <tr>
          <th>Elemento:</th>
          <td>{{ visation.taskElement || 'N/A' }}</td>
          <th>Fecha solicitud de cambio:</th>
          <td>{{ visation.requestedDate | date: 'dd/MM/yyyy' }}</td>
        </tr>
        <tr>
          <th>Criterio:</th>
          <td>{{ visation.taskAcceptanceCriteria || 'N/A' }}</td>
          <th>Fecha creación:</th>
          <td>{{ visation.effectiveDate | date: 'dd/MM/yyyy' }}</td>
        </tr>
      </tbody> <!-- Cerrado el tbody -->
    </table>

    <!-- Tabla para pantallas pequeñas con <tbody> -->
    <table class="table table-report-info w-full mb-4 md:hidden">
      <tbody> <!-- Agregado el tbody -->
        <tr>
          <th>Solicitante:</th>
          <td>{{ visation.requestingUser.username }}</td>
        </tr>
        <tr>
          <th>Tipo de cambio:</th>
          <td>{{ visation.changeType }}</td>
        </tr>
        <tr>
          <th>Tarea:</th>
          <td>{{ visation.task || 'N/A' }}</td>
        </tr>
        <tr>
          <th>Estado:</th>
          <td>{{ visation.action.name }}</td>
        </tr>
        <tr>
          <th>Elemento:</th>
          <td>{{ visation.taskElement || 'N/A' }}</td>
        </tr>
        <tr>
          <th>Fecha solicitud de cambio:</th>
          <td>{{ visation.requestedDate | date: 'dd/MM/yyyy' }}</td>
        </tr>
        <tr>
          <th>Criterio:</th>
          <td>{{ visation.taskAcceptanceCriteria || 'N/A' }}</td>
        </tr>
        <tr>
          <th>Fecha creación:</th>
          <td>{{ visation.effectiveDate | date: 'dd/MM/yyyy' }}</td>
        </tr>
      </tbody> <!-- Cerrado el tbody -->
    </table>

    <!-- Sección modificada de la plantilla -->


    <div class="single-page-content">
      <h3 class="text-primary-700 text-xl">Historial de solicitud</h3>
    
      <div class="transition-width pr-4">
        <app-table [columns]="tableColumns" [data]="flattenedActionsData">
          <ng-template #actionTemplate let-visationAction>
            <div class="action-buttons">
              <a [href]="createDownloadLink(visationAction.filePath)" [download]="visationAction.originalFileName" title="Descargar documento">
                <i class="fa-solid fa-file"></i>
              </a>
            </div>
          </ng-template>
        </app-table>
      </div>
    </div>
    

    
    <div class="flex justify-center mt-4 gap-4">
      <button class="button button-danger" (click)="reject()">Rechazar</button>
      <button class="button button-warning" (click)="return()">Devolver</button>
      <button class="button button-success" (click)="approve()">Aprobar</button>
    </div>
  </div>
</div>

<ng-template #loading>
  <div>Cargando detalles de la visación...</div>
</ng-template>
